export interface Campaign {
  id: string;
  name?: string;
  affiliate_id: string;
  conversionApi?: boolean;
  offer_id: any;
  excludedIP?: any;
  pixelId?: string;
  pay?: number;
  fbAccessToken?: string;
  timestamp?: any;
  checkDoubles: boolean;
  pause?: boolean;
  url?: string;
  country?: string;
  privacyUrl?: string;
  // minHour?: number[];
  // maxHour?: number[];
  dailyMax?: number;
  // dailyMax?: DailyMax;
  category?: string;
  dayOfTheWeek?: boolean[];
  access_token?: string;
  checkPhoneNumber?: boolean;
  verifyOptin?: boolean;
  verify?: boolean;
}

// dailyMax:{"type":"weekly", "days": {"0": {"pause": bool, "maxleads": 0, "timestart": 0000, "timeend": 0000}}}
// export interface DailyMax {
//   type: string;
//   days: Days;
// }

// Tipi dei giorni: se le chiavi sono stringhe numeriche (come in JSON), devono essere stringhe.
// export type Days = {
//   [key in '0' | '1' | '2' | '3' | '4' | '5' | '6']: DailyMaxDayConfig;
// };

// export interface DailyMaxDayConfig {
//   pause: boolean;
//   maxleads: number;
//   timestart: number; 
//   timeend: number;  
// }


export abstract class CampaignData {
  abstract createCampaign(Campaign: Campaign);
  abstract getCampaigns(pagination, filter, order);
  abstract getCampaign(id: string);
  abstract editCampaign(data: Campaign, id: string);
  abstract deleteCampaign(id: string);
}

